import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    getPaymentGatewaySuccess,
    getPaymentGatewayError,
    getTransactionConfirmationSuccess,
    getTransactionConfirmationError
} from './investFundAction';
import { PAYMENT_GATEWAY_REQ, TRANSACTION_CONFIRMATION_REQUEST, } from '../actionType';
import { CONFIRM_TRANSACTION, LLAPIURL} from '../../../utils/urls';
import {fetchGet, fetchPaymentGateway} from '../../../utils/request';

const stateInvestFund = (state: any) => state.investFund;
const stateDashboard = (state: any) => state.dashboard;
function* getGatewayReq(): any {
    const stateValue = yield select(stateInvestFund);
    const stateDashboardValue = yield select(stateDashboard);
    let body = {
        "TransactionAmount": stateValue.addMoneyAmount,
        "Lockin":stateDashboardValue?.tenureValue
    }
    try {
        const response = yield call(fetchPaymentGateway, LLAPIURL, body);
        yield put(getPaymentGatewaySuccess(response));
        if (response.error) {
            if(response?.error?.errors?.detail){
                yield put(getPaymentGatewayError(response?.error?.errors?.detail));
            }else{
                yield put(getPaymentGatewayError(response?.error?.errors));
            }
            return false;
        }
        return true;
    } catch (error) {
        yield put(getPaymentGatewayError("Internal Server Error"));
    }
}

function* fetchTransConfirmation():any {
    try {
        const response = yield call(fetchGet, CONFIRM_TRANSACTION);
        console.log("response:", response);
        // if(response.status){
            yield put(getTransactionConfirmationSuccess(response));
            return true;
        // } 
    } catch (error) {
        yield put(getTransactionConfirmationError(error));
    }
}

export default function* sagaInvestFund() {
    yield all([
        takeLatest(PAYMENT_GATEWAY_REQ, getGatewayReq),
        takeLatest(TRANSACTION_CONFIRMATION_REQUEST, fetchTransConfirmation)
    ])
}